var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { requestPlatform } from '../request/request_old';
import { getLang } from '../i18n/tools';
import Cookie from 'js-cookie';
import { to } from '@tencent/vb-web-base-core';
import { t } from './locales/index';
export var OpenAccountState;
(function (OpenAccountState) {
    /** 初始状态 */
    OpenAccountState[OpenAccountState["OPENACCOUNT_STATE_INIT"] = 0] = "OPENACCOUNT_STATE_INIT";
    /** 已废弃 */
    OpenAccountState[OpenAccountState["OPENACCOUNT_STATE_WASTE"] = 1] = "OPENACCOUNT_STATE_WASTE";
    /** 资料已全部提交 */
    OpenAccountState[OpenAccountState["OPENACCOUNT_STATE_WAIT"] = 5] = "OPENACCOUNT_STATE_WAIT";
    /** 资料审核中 */
    OpenAccountState[OpenAccountState["OPENACCOUNT_STATE_CHECKING"] = 10] = "OPENACCOUNT_STATE_CHECKING";
    /** 审核未通过，一个月后才能重新开户 */
    OpenAccountState[OpenAccountState["OPENACCOUNT_STATE_CHECK_NOT_PASS"] = 15] = "OPENACCOUNT_STATE_CHECK_NOT_PASS";
    /** 需要重新补充资料，特指入境小票 */
    OpenAccountState[OpenAccountState["OPENACCOUNT_STATE_NEED_MODIFY"] = 20] = "OPENACCOUNT_STATE_NEED_MODIFY";
    /** 审核驳回，需要重新开户 */
    OpenAccountState[OpenAccountState["OPENACCOUNT_STATE_CHECK_RESTART"] = 21] = "OPENACCOUNT_STATE_CHECK_RESTART";
    /** 审核已通过，待开户 */
    OpenAccountState[OpenAccountState["OPENACCOUNT_STATE_CHECK_PASS"] = 25] = "OPENACCOUNT_STATE_CHECK_PASS";
    /** 开户成功 */
    OpenAccountState[OpenAccountState["OPENACCOUNT_STATE_SUCC"] = 30] = "OPENACCOUNT_STATE_SUCC";
    /** 开户失败，需要重新开户，返回的 result 内包含失败原因，参考 enum GET_INFO_ERROR */
    OpenAccountState[OpenAccountState["OPENACCOUNT_STATE_FAIL"] = 35] = "OPENACCOUNT_STATE_FAIL";
    /** 销户中 */
    OpenAccountState[OpenAccountState["CLOSEACCOUNT"] = 40] = "CLOSEACCOUNT";
})(OpenAccountState || (OpenAccountState = {}));
export function getCardListCGI() {
    return __awaiter(this, void 0, void 0, function () {
        var lang, CGI, _a, listInfo, error, bindSuc;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getLang()];
                case 1:
                    lang = _b.sent();
                    CGI = '/node/deposit/entry/getCardList?pageSize=99&pageStart=0';
                    return [4 /*yield*/, to(requestPlatform(CGI))];
                case 2:
                    _a = _b.sent(), listInfo = _a[0], error = _a[1];
                    if (error) {
                        throw { code: error.status, message: t('系统繁忙, 请稍后再试', lang), tag: 'getCardListError' };
                    }
                    if (listInfo.code !== 0) {
                        throw { code: listInfo.code, message: listInfo.message || '', tag: 'getCardListProblem' };
                    }
                    bindSuc = listInfo.data.card_list || [];
                    if (bindSuc.length > 0) {
                        bindSuc = bindSuc.filter(function (i) {
                            return i.edda_state === 10;
                        });
                    }
                    return [2 /*return*/, bindSuc];
            }
        });
    });
}
export function getUserStatusCGI() {
    return __awaiter(this, void 0, void 0, function () {
        var lang, CGI, _a, respData, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getLang()];
                case 1:
                    lang = _b.sent();
                    CGI = '/node/account/user/status';
                    return [4 /*yield*/, to(requestPlatform(CGI))];
                case 2:
                    _a = _b.sent(), respData = _a[0], error = _a[1];
                    if (error) {
                        throw { code: error.status, message: t('系统繁忙, 请稍后再试', lang), tag: 'getUserStatusError' };
                    }
                    if (respData.code !== 0) {
                        throw { code: respData.code, message: respData.message || '', tag: 'getUserStatusProblem' };
                    }
                    return [2 /*return*/, respData.data];
            }
        });
    });
}
var deviceId = Cookie.get('deviceId');
export function getOpenAccountInfoCGI() {
    return __awaiter(this, void 0, void 0, function () {
        var lang, _a, respData, error;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getLang()];
                case 1:
                    lang = _b.sent();
                    return [4 /*yield*/, to(requestPlatform('/node/account/getOpenAccountInfo', 'GET', {
                            deviceId: deviceId,
                            restart: 0, // 这里只是查询的 设置为0
                        }))];
                case 2:
                    _a = _b.sent(), respData = _a[0], error = _a[1];
                    if (error) {
                        throw { code: error.status, message: t('系统繁忙, 请稍后再试', lang), tag: 'getOpenAccountError' };
                    }
                    if (respData.code !== 0) {
                        throw { code: respData.code, message: respData.message || '', tag: 'getOpenAccountProblem' };
                    }
                    return [2 /*return*/, respData.data];
            }
        });
    });
}
